// Module
var code = "<template> <require from=\"app/cm/components/household/tasks-grid\"></require> <tasks-grid household-case-id.bind=\"householdCaseId\" tasks-config.bind=\"tasksConfig\" queues-config.bind=\"queuesConfig\" assessments-config.bind=\"assessmentsConfig\"></tasks-grid> </template> ";
// Exports
module.exports = code;